import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { inDemoMode, inReadOnlyMode, inSupportMode } from '@lib/remote-login';

@Injectable()
export class ModeAccessGuard {
  private modes: {[key: string]: () => boolean} = {
    'demo': inDemoMode,
    'viewOnly': inReadOnlyMode,
    'support': inSupportMode,
  };

  constructor(private router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const config = route.data?.modeGaurd?.config;
    if (!config) {
      throw(new Error('ModeAccessGaurd: config is missing'));
    }
    let allowNavigation = true;
    Object.keys(config).forEach(modeKey => {
      allowNavigation = this.modes[modeKey]() === config[modeKey];
      if (!allowNavigation) {
        this.router.navigate(['/']);
        return false;
      }
    });
    return true;
  }
}
